export enum EditMode {
  None,
  Crop,
  Resize,
  Rotate,
  Filter,
  Watermark,
  Deskew,
  Animation,
  Merge,
  ObjectDetection,
}
